import React from 'react';
import {useField, useFormikContext} from 'formik';

import {Row} from '../layout';
import ErrorMessage from './ErrorMessage';
import Icon from '../icon';
import {Icons} from '../../util/icons';
import colors from '../../util/colors';
import './styles.scss';
import AppCheckboxInput from '../input/app-checkbox-input/AppCheckboxInput';
import {Store} from '../../store';

interface AppFormCheckboxFieldProps extends React.HTMLProps<HTMLInputElement> {
  label: any;
  labelClass?: string;
  name: string;
  showErrorMessage?: boolean;
  onChange?: any;
  handleFormikContext?: any;
  showIcon?: boolean;
  className?: string;
  purposeId?: string;
  value?: any;
  defaultColor?: boolean;
  error?: any;
  errorStyle?: any;
}

function AppFormCheckboxField({
  label,
  labelClass,
  name,
  handleFormikContext,
  onChange,
  className,
  showErrorMessage = false,
  showIcon = false,
  purposeId,
  value,
  defaultColor,
  error,
  errorStyle,
}: AppFormCheckboxFieldProps) {
  const formik = useFormikContext();
  const {setFieldTouched, errors, touched, setFieldValue, submitCount} = formik;

  const newError =
    typeof error === 'boolean'
      ? Store.getState().strings.value.pt.messages.requiredField
      : error || (errors as any)[name];
  const formikError = (errors as any)[name];
  const visible = (touched as any)[name] || submitCount > 0;

  // Final error (only show if visible)
  const displayError = newError ?? (visible ? formikError : undefined);

  const [field] = useField(name);
  if (!!handleFormikContext) {
    handleFormikContext(formik);
  }

  return (
    <Row className="app-form-date-picker-field-container">
      {showErrorMessage && !!displayError && formik.submitCount > 0 && (
        <div style={errorStyle} className="app-form-field-error-content">
          <Icon
            name={Icons.ALERT_PROBLEM}
            color={colors.alertRed}
            width="24"
            height="24"
          />
          <ErrorMessage error={newError} visible={!!displayError} />
        </div>
      )}
      <AppCheckboxInput
        purposeId={purposeId}
        className={`${className}${
          showErrorMessage &&
          !!displayError &&
          formik.submitCount > 0 &&
          ' invalid-app-form-field'
        }`}
        value={value ? value : field.value}
        label={label}
        labelClass={labelClass}
        name={name}
        checked={value ? value : field.value}
        onChange={(value) => {
          onChange ? onChange(value) : setFieldValue(name, value);
          formik.setFieldError(name, undefined);
        }}
        onBlur={() => setFieldTouched(name)}
      />
    </Row>
  );
}

export default AppFormCheckboxField;
